<template>
  <div>
    <h1>Alle Stunden für {{ date.format("DD.MM.yyyy") }}</h1>
    <p>
      Stunden in KW {{ date.format("W") }}:
      {{ workingHours.workHoursCurrentWeek | hour }}/{{
          workingHours.workHoursRequiredCurrentWeek | hour
      }}
    </p>
    <!--<p>Stunden im Monat {{date.format("MMMM")}}: {{workingHours.workHoursCurrentMonth | hour}}/{{workingHours.workHoursRequiredCurrentMonth | hour}}</p>
    <p>Stunden im Jahr {{date.format("yyyy")}}: {{workingHours.workHoursCurrentYear | hour}}/{{workingHours.workHoursRequiredCurrentYear | hour}}</p>-->
    <p>
      Stunden aktuelles Jahr bis letzten Monat:
      {{
          (workingHours.workHoursUntilLastMonth -
            workingHours.workHoursRequiredUntilLastMonth)
          | hour
      }}
    </p>
    <rules :date="date.format('yyyy/MM/DD')"></rules>
    <hr />
    <a v-on:click="setPreviousDate" class="btn btn-info">Gehe zu {{ previousDate.format("DD.MM.yyyy") }}</a>
    |
    <a v-on:click="setNextDate" class="btn btn-info">Gehe zu {{ nextDate.format("DD.MM.yyyy") }}</a>
    <hr />
    <div v-if="hours.length > 0">
    <div class="container-fluid">
      <div class="row d-none d-md-flex bg-light py-2">
        <div class="col-md-1">Von</div>
        <div class="col-md-1">Bis</div>
        <div class="col-md-2">Projekt</div>
        <div class="col-md-1">Aufgabennummer</div>
        <div class="col-md-2 pl-4">Aufgabentitel</div>
        <div class="col-md-1">Zahler</div>
        <div class="col-md-2">Kommentar</div>
        <div class="col-md-1">Status</div>
        <div class="col-md-1">Optionen</div>
      </div>
      <HourRow v-for="hour in hours" :hours="originalHours" :hour="hour" :date="date.format('yyyy/MM/DD')" :azureProjects="azureProjects"
        :projects="projects" :azureConnection="azureConnection" @deleteHour="deleteHour"
        @setHighestDayHour="setHighestDayHour" @replaceHour="replaceHour" :key="hour.id">
      </HourRow>
    </div>
  </div>

    <div v-else>Noch keine Stunden für den Termin eingetragen.</div>
    <a class="btn btn-success mt-2" @click="createHour">+</a>
  </div>
</template>

<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>

<script>
import axios from "axios";
import moment from "moment";
import HourRow from "./hourRow.vue";
import Rules from "../rules/rules";
import AzureHelper from "../../helper/AzureHelper";
import Vue from "vue";

export default {
  components: {
    HourRow,
    Rules,
  },
  name: "hours",
  data() {
    return {
      hours: [],
      originalHours: [],
      workingHours: {},
      projects: [],
      azureConnection: null,
      azureProjects: [],
      date: moment(),
      previousDate: moment(),
      nextDate: moment(),
      highestDayHour: "10:00",
    };
  },
  methods: {
    /**
      * Summary: Create Azure Connection and store in the state
    */
    getAzureConn: function () {
      try {
        const {
          VUE_APP_ORGANIZATION_NAME,
          VUE_APP_ORGANIZATION_URI,
          VUE_APP_AZURE_PERSONAL_ACCESS_TOKEN,
        } = process.env;
        const azure = new AzureHelper(
          VUE_APP_ORGANIZATION_NAME,
          VUE_APP_ORGANIZATION_URI,
          VUE_APP_AZURE_PERSONAL_ACCESS_TOKEN
        );
        this.azureConnection = azure;
        return this.azureConnection;
      } catch (error) {
        console.log(error);
      }
    },
    /**
      * Summary: Get Azure Projects using connection from state
    */
    getAzureProjects: async function () {
      try {
        // check azure repeated api calls, prevent multiple calls
        console.log("getAzureProjects() called");
        const projects = await this.azureConnection.getProjects()
        this.azureProjects = projects
        return this.azureProjects;
      } catch (error) {
        console.log(error);
      }
    },
    setHighestDayHour: function (highestDayHour) {
      this.highestDayHour = highestDayHour;
    },
    replaceHour: function (oldId, newHour) {
      var indexToReplace = -1;
      for (var i = 0; i < this.hours.length; i++) {
        if (this.hours[i].id == oldId) {
          indexToReplace = i;
        }
      }
      if (indexToReplace >= 0) {
        Vue.set(this.hours, indexToReplace, newHour);
      }
    },
    setPreviousDate: function () {
      this.setDate(this.previousDate);
    },

    setNextDate: function () {
      this.setDate(this.nextDate);
    },
    setDate: function (date) {
      this.$router.push("/hours?date=" + date.format("yyyy-MM-DD"));
    },
    createHour: function () {
      var hour = {
        id: -(Math.floor(Math.random() * (10 - 1 + 1)) + 1),
        projectId: 0,
        from: this.date.format("yyyy/MM/DD") + " " + this.highestDayHour,
        to: this.date.format("yyyy/MM/DD") + " " + this.highestDayHour,
        comment: "",
        inHomeOffice: false,
        userId: "ThisIsJustHereToPreventValidationErrors",
        createdOn: moment().format("YYYY-MM-DD"),
      };
      this.hours.push(hour);
    },
    deleteHour: function (id) {
      var indexToRemove = -1;
      for (var i = 0; i < this.hours.length; i++) {
        if (this.hours[i].id == id) {
          indexToRemove = i;
        }
      }
      this.hours.splice(indexToRemove, 1);
    },
    loadComponentData: function () {
      //Load projects
      axios({
        method: "GET",
        url: process.env.VUE_APP_API_PATH + "projects/",
      }).then(
        (result) => {
          this.projects = result.data;
        },
        (error) => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );

      //Load hours
      axios({
        method: "GET",
        url:
          process.env.VUE_APP_API_PATH +
          "hours/GetByUserAndDate?date=" +
          this.date.format("yyyy-MM-DD"),
      }).then(
        (result) => {
          this.hours = result.data;
          this.originalHours = result.data;
          let moments = this.hours.map((h) => moment(h.to));
          if (moments.length > 0) {
            this.highestDayHour = moment.max(moments).format("HH:mm");
          } else {
            this.highestDayHour = "10:00";
          }
        },
        (error) => {
          console.error(error);
          this.highestDayHour = "10:00";
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );

      axios({
        method: "GET",
        url:
          process.env.VUE_APP_API_PATH +
          "hours/GetRequiredWorkingHours?date=" +
          this.date.format("yyyy-MM-DD"),
      }).then(
        (result) => {
          this.workingHours = result.data;
        },
        (error) => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        }
      );
    },
  },
  async created() { },
  async mounted() {
    //Set date to today
    var currentDate = moment();
    if (this.$route.query.date) {
      this.date = moment(this.$route.query.date);
      this.previousDate = moment(this.$route.query.date).subtract(1, "d");
      this.nextDate = moment(this.$route.query.date).add(1, "d");
      this.loadComponentData();
      this.getAzureConn();
      this.getAzureProjects();
    } else {
      this.setDate(currentDate);
    }
  },
  updated() {
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.date = moment(to.query.date);
    this.previousDate = moment(to.query.date).subtract(1, "d");
    this.nextDate = moment(to.query.date).add(1, "d");
    this.getAzureConn();
    this.getAzureProjects();
    this.loadComponentData();
  },
};
</script>
